var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.66 9.3877L23.3239 9.3877C25.9046 9.3877 28.0002 11.4833 28.0002 14.0516C28.0002 16.6323 25.9046 18.7155 23.3239 18.7155L18.66 18.7155L18.66 23.3918C18.66 25.9601 16.5768 28.0557 13.9961 28.0557C11.4154 28.0557 9.33215 25.9601 9.33215 23.3918L9.33215 18.7155C9.33215 13.5902 13.5346 9.3877 18.66 9.3877Z","fill":"#FF5C5C","key":0}),React.createElement("path",{"d":"M18.6682 9.3835C18.6682 14.5351 14.492 18.7113 9.34039 18.7113L4.6641 18.7113C2.09579 18.7125 0.000183106 16.6281 0.000183106 14.0485C0.000183106 11.4791 2.09579 9.38462 4.6641 9.38462L9.34039 9.38462L9.34039 4.71958C9.34039 2.13889 11.4236 0.0556641 14.0043 0.0556641C16.585 0.0556641 18.6682 2.13889 18.6682 4.71958L18.6682 9.3835Z","fill":"#FDAC42","key":1})]);
}

Logo.defaultProps = {"width":"28","height":"29","viewBox":"0 0 28 29","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
